import React from 'react';

import {Trans} from '../../../../../../libs/shared/core/src/helpers/internationalization/react';
import {TeammateModel} from '../../../../../../libs/shared/core/src/models/api/teammateModel';
import {ViewerPanelId} from '../../../../../../libs/shared/core/src/store/panels/panelStateBase';
import {TeammateNamePreviewer} from '../../../../teammateCard/teammateCardPreviewer';

/*
 * Variant of srcCommon/.../referencedActivityTextHelpers.tsx with interactive teammates.
 */

export function renderSentReference(
  from: TeammateModel,
  to: TeammateModel,
  userId: number,
  panelId: ViewerPanelId,
) {
  const fromTeammatePreview = <TeammateNamePreviewer teammate={from} panelId={panelId} shouldCapitalizeYou />;
  const toTeammatePreview = <TeammateNamePreviewer teammate={to} panelId={panelId} />;

  if (from.id === to.id) {
    return from.id === userId ? (
      <Trans id="timeline-comment-selfreference-user">{fromTeammatePreview} replied to yourself</Trans>
    ) : (
      <Trans id="timeline-comment-selfreference-other">{fromTeammatePreview} replied to themselves</Trans>
    );
  }

  return (
    <Trans id="timeline-comment-reference">
      {fromTeammatePreview} replied to {toTeammatePreview}
    </Trans>
  );
}

export function renderDraftReference(to: TeammateModel, userId: number, panelId: ViewerPanelId) {
  if (to.id === userId) {
    return <Trans id="composer-comment-selfreference">Replying to yourself</Trans>;
  }

  const toTeammatePreview = <TeammateNamePreviewer teammate={to} panelId={panelId} />;

  return <Trans id="composer-comment-reference">Replying to {toTeammatePreview}</Trans>;
}
